import Model from "../Model";

export interface TReportingPeriodPermission {
  id: number;
  applicantReportingPeriodId: number;
  userCode: string;
  action: string;
  fromDate: Date;
  toDate?: Date;
}

export interface IReportingPeriodPermission
  extends TReportingPeriodPermission {}

const ReportingPeriodPermission = Model(
  (model: TReportingPeriodPermission): IReportingPeriodPermission => {
    const _reportingPeriodPermission: TReportingPeriodPermission = Object.assign(
      {},
      model
    );

    return {
      get id() {
        return _reportingPeriodPermission.id;
      },
      get applicantReportingPeriodId() {
        return _reportingPeriodPermission.applicantReportingPeriodId;
      },
      get userCode() {
        return _reportingPeriodPermission.userCode;
      },
      get action() {
        return _reportingPeriodPermission.action;
      },
      get fromDate() {
        return _reportingPeriodPermission.fromDate;
      },
      get toDate() {
        return _reportingPeriodPermission.toDate;
      },

      set applicantReportingPeriodId(value: any) {
        _reportingPeriodPermission.applicantReportingPeriodId = value;
      },
      set userCode(value: any) {
        _reportingPeriodPermission.userCode = value;
      },
      set action(value: any) {
        _reportingPeriodPermission.action = value;
      },
      set fromDate(value: any) {
        _reportingPeriodPermission.fromDate = value;
      },
      set toDate(value: any) {
        _reportingPeriodPermission.toDate = value;
      }
    };
  }
);

export default ReportingPeriodPermission;
